import { MultiLanguageString } from "@/lib/api/stays/types/shared-types";

// Helper function to extract localized text
export const getLocalizedText = (
  field: MultiLanguageString | string | undefined,
  locale: keyof MultiLanguageString = "pt_BR"
): string => {
  if (typeof field === "string") {
    return field;
  }
  if (field && typeof field === "object" && field !== null) {
    if (locale in field && field[locale]) {
      return field[locale]!;
    }
    if ("pt_BR" in field && field.pt_BR) {
      return field.pt_BR!;
    }
    const firstValue = Object.values(field).find(
      (value) => typeof value === "string" && value
    );
    if (firstValue) {
      return firstValue as string;
    }
  }
  return ""; // Return empty string for missing translations
};
